module.exports = __webpack_public_path__ + "static/media/belcolor__5.ab4f4d89.jpg";